import React from 'react';
import { Phone } from 'lucide-react';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./FidiumProvider.css";
import logo1 from "../../Includes/Images/Group-1171274818-1.png";
import provider1 from "../../Includes/Images/Group-12.png";
import provider2 from "../../Includes/Images/Rectangle-5-1.png";
import provider3 from "../../Includes/Images/Group-1171274817-1.png";
import WideCoverage from './WideCoverage';
// Import any additional images you might need
// import chatBubbleImg from "../../Includes/Images/chat-bubble.png";
// import heroPersonImg from "../../Includes/Images/hero-person.png";

const FidiumProvider = () => {
  const phoneNumber = "+1-888-348-6689";
  
  return (
    <>
    <Header/>
    <div className="fidium-provider-container">
      {/* Header Section */}
      <div className="fidium-header text-white p-6 flex flex-col md:flex-row justify-between items-center">
        <div className="fidium-logo-section mb-4 md:mb-0">
          <img src={logo1} alt="Fidium Logo" className="mb-4" />
          <h1 className="fidium-title text-3xl font-bold mb-2">Fidiumize Your Life With A Fiber Internet</h1>
          <p className="fidium-subtitle mb-4">
            Fidium Fiber Delivers A 100% Fiber Connection To Your Home. That Means, While Cable Internet Customers Are Starting Buffering During Peak Neighborhood, You're Getting Direct-To-Home Bandwidth 24/7, Over The Fastest, Most Reliable Technology Available.
          </p>
          <button className="fidium-cta-button bg-green-500 text-white py-2 px-6 rounded-full flex items-center">
            <Phone size={20} className="mr-2" />
            <span>{phoneNumber}</span>
          </button>
        </div>
        
        {/* Add the hero image section that was missing */}
        <div className="fidium-hero-image relative">
          <div className="fidium-chat-bubble bg-white rounded-xl p-2 absolute">
            <div className="fidium-avatar-group flex">
              <div className="rounded-full bg-gray-200 w-8 h-8 flex items-center justify-center">U</div>
              <div className="rounded-full bg-gray-200 w-8 h-8 flex items-center justify-center -ml-2">U</div>
              <div className="rounded-full bg-gray-200 w-8 h-8 flex items-center justify-center -ml-2">U</div>
            </div>
            <span className="text-xs text-gray-700">Happy Clients!</span>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="fidium-features-section p-6 flex flex-col md:flex-row justify-between items-center">
        <div className="fidium-metrics flex mb-6 md:mb-0">
          <div className="fidium-metric mr-6">
            <h3 className="fidium-metric-value text-2xl font-bold text-blue-600">100%</h3>
            <p className="fidium-metric-label">Fiber Connection</p>
          </div>
          <div className="fidium-metric">
            <h3 className="fidium-metric-value text-2xl font-bold text-blue-600">24/7</h3>
            <p className="fidium-metric-label">Direct-To-Home Bandwidth</p>
          </div>
        </div>
        
        <div className="fidium-feature-images">
          <img src={provider1} alt="People using internet" className="rounded-lg mb-4" />
        </div>
        
        <div className="fidium-feature-content">
          <h2 className="fidium-section-title text-2xl font-bold mb-2">Experience Better, Faster Internet</h2>
          <p className="fidium-feature-description mb-4">
            With Stronger WiFi, There's No Buffering, No Lag And No Slowing Down, Especially During Peak Hours.
          </p>
          <p className="fidium-feature-description mb-4">
            Get Smoother Streaming TV, Faster Gaming And A Better Remote Work Experience — No Matter How Many Bandwidth Hogs You Have At Home!
          </p>
          <button className="fidium-cta-button bg-green-500 text-white py-2 px-6 rounded-full flex items-center">
            <Phone size={20} className="mr-2" />
            <span>{phoneNumber}</span>
          </button>
        </div>
      </div>

      {/* Multi-Gig Section */}
      <div className="fidium-multi-gig-section text-white p-6">
        <h2 className="fidium-section-title text-2xl font-bold mb-4">Experience Multi-Gig Speeds</h2>
        <p className="fidium-section-description mb-6">
          Take Your Internet To A Whole New Level. Fidium Delivers Equal 2 Gig Upload And Download Speeds, Something Cable Internet Providers Can't Do.
        </p>
        
        <div className="fidium-benefits-grid grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="fidium-benefit bg-white p-4 rounded-lg text-black text-center">
            <div className="fidium-benefit-icon bg-blue-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
              <span>📄</span>
            </div>
            <h3 className="fidium-benefit-title font-bold">No Contracts</h3>
            <p className="fidium-benefit-description">
              Freedom To Change Your Plan Whenever You Want
            </p>
          </div>
          
          <div className="fidium-benefit bg-white p-4 rounded-lg text-black text-center">
            <div className="fidium-benefit-icon bg-blue-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
              <span>❌</span>
            </div>
            <h3 className="fidium-benefit-title font-bold">No Bundling</h3>
            <p className="fidium-benefit-description">
              Only Pay For The Services You Need
            </p>
          </div>
          
          <div className="fidium-benefit bg-white p-4 rounded-lg text-black text-center">
            <div className="fidium-benefit-icon bg-blue-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
              <span>📊</span>
            </div>
            <h3 className="fidium-benefit-title font-bold">No Data Cap</h3>
            <p className="fidium-benefit-description">
              Never Run Out Of Data
            </p>
          </div>
        </div>
      </div>

      {/* Business Section */}
      <div className="fidium-business-section text-white p-6 flex flex-col md:flex-row items-center">
        <div className="fidium-business-content md:w-1/2 mb-6 md:mb-0">
          <h2 className="fidium-section-title text-2xl font-bold mb-2">
            Get Fast Fiber Internet With <span className="text-green-400">Fidium@Work</span>
          </h2>
          <p className="fidium-business-description mb-4">
            Get Fast Fiber Internet With Fidium@Work. Quick Installation With Affordable And Dependable Pricing, So You Can Focus On Servicing Your Customers, Not Your Internet Service.
          </p>
          <p className="fidium-business-description mb-4">
            You'll Experience The Most Advanced, Fastest Fiber Internet To Make Life Better For Everyone. That Means Pricing You Can Afford, Removing Fees And Data Caps.
          </p>
          <button className="fidium-cta-button bg-green-500 text-white py-2 px-6 rounded-full flex items-center">
            <Phone size={20} className="mr-2" />
            <span>{phoneNumber}</span>
          </button>
        </div>
        <div className="fidium-business-image md:w-1/2">
          <img src={provider2} alt="Business people using internet" className="rounded-lg" />
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="fidium-testimonials-section p-6 text-center">
        <h2 className="fidium-section-title text-3xl font-bold mb-4">
          Thank You For Making Us The People's <span className="text-green-500">Internet</span>
        </h2>
        
        <div className="fidium-awards-grid flex flex-wrap justify-center gap-4">
          {/* Display multiple award badges for better visual impact */}
            <div className="fidium-award-badge bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center">
              <img src={provider3} alt="Award"  className="rounded-full w-12 h-12" />
            </div>
        </div>
      </div>

      {/* Plans Section */}
      <div className="fidium-plans-section text-white p-6">
        <h2 className="fidium-section-title text-2xl font-bold mb-2">
          Simply Choose The Speed You Need
        </h2>
        <p className="fidium-section-description mb-6">
          With Ultra-Fast Connections, 100% Fiber Internet, WiFi And Symmetrical Upload And Download Speeds, It's No Wonder Customers Dig The Fidium Dig.
        </p>
        
        <div className="fidium-plans-grid grid grid-cols-1 md:grid-cols-4 gap-4">
          {[
            {
              speed: "100 Mbps",
              name: "Essential",
              description: "Browse And Surf The Web For All Your Basic Internet Needs"
            },
            {
              speed: "50 Mbps",
              name: "Advanced",
              description: "For Households With Multiple Users Who Frequently Stream Content"
            },
            {
              speed: "1 Gig",
              name: "Supreme",
              description: "Perfect For Power Users, Large Families And Lag-Free Gaming"
            },
            {
              speed: "100 Mbps",
              name: "Futuristic",
              description: "The Ultimate Internet For Advanced Users And Home Offices"
            }
          ].map((plan, index) => (
            <div key={index} className="fidium-plan bg-white p-4 rounded-lg text-black">
              <h3 className="fidium-plan-speed text-2xl font-bold">{plan.speed}</h3>
              <h4 className="fidium-plan-name font-bold mb-4">{plan.name}</h4>
              <p className="fidium-plan-description mb-4">{plan.description}</p>
              <button className="fidium-cta-button bg-blue-600 text-white py-2 px-4 rounded-full flex items-center justify-center w-full">
                <Phone size={16} className="mr-2" />
                <span>{phoneNumber}</span>
              </button>
            </div>
          ))}
        </div>
        
        <p className="fidium-disclaimer text-xs mt-6 text-center">
          *Broadband plans are subject to availability and location verification. Limited time offer varies by market.
          Call {phoneNumber} for additional information.
        </p>
      </div>
    </div>
    <WideCoverage/>
    <Footer/>
    </>
  );
};

export default FidiumProvider;